var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M10.5 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M9.07 10 6.21 7.14a1.01 1.01 0 0 1 1.43-1.43l2.86 2.86 2.86-2.86a1.01 1.01 0 0 1 1.43 1.43L11.93 10l2.86 2.86a1.01 1.01 0 1 1-1.43 1.43l-2.86-2.86-2.86 2.86a1.01 1.01 0 0 1-1.43-1.43L9.07 10Z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "currentColor",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgCloseCircle;